module.exports = __webpack_public_path__ + "img/core-1.df3e84c.svg";